import SignatureTable from 'components/tables/data/signature/SignatureTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';

/**
 * Page used to display signatures grouped by KEP message UUID.
 */
export default function SignaturesPage() {
  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Podpisovanie' }]}>
      <SignatureTable />
    </DashboardLayout>
  );
}
